import React, { memo } from 'react';
export function EmotionalTransition() {
  return <section className="py-20 md:py-32 bg-zinc-950 px-4" data-id="element-56">
      <div className="max-w-3xl mx-auto text-center space-y-10" data-id="element-57">
        <p className="text-xl md:text-2xl text-stone-200 leading-relaxed" data-id="element-58">
          Se ti sei sentito frustrato perché i tuoi studenti non avanzano come
          dovrebbero, sappi che non dipende dalla tua passione per il tango.
          Molto spesso il vero problema è la mancanza di un sistema di
          insegnamento chiaro, coinvolgente e facile da applicare.
        </p>

        <p className="text-2xl md:text-3xl text-white font-bold leading-tight" data-id="element-59">
          La verità è che oggi non basta saper ballare bene per essere un
          insegnante memorabile. Serve un metodo capace di mantenere alta
          l'attenzione, creare progressione reale e trasformare ogni lezione in
          un'esperienza che lo studente desidera continuare.
        </p>

        <p className="text-xl text-amber-200 leading-relaxed font-medium" data-id="element-60">
          Ed è proprio qui che tutto cambia: quando inizi a insegnare con una
          struttura più intelligente, le lezioni diventano più semplici da
          preparare, gli studenti partecipano di più e i risultati iniziano
          finalmente a vedersi davvero.
        </p>
      </div>
    </section>;
}